<template>
  <div class="page-solicitation">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <!-- <el-form-item label="展厅名称 :" prop="name">
              <el-select v-model="form.name" placeholder="请选择">
                <el-option v-for="(item, index) in recruitList" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="选择日期 :" prop="date">
              <el-date-picker v-model="form.date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                placeholder="请选择"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="com-head-search-btns">
        <el-button type="primary" @click="getExhibitionDetailList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <div v-loading="tableLoading" class="table-wrapper com-list-content">
      <div class="button mb-20">
        <el-row>
          <el-button class="el-primary-border" round @click="showDialog">
            <svg-icon icon-class="daochu" />&nbsp;导出
          </el-button>
        </el-row>
      </div>
      <template>
        <div class="header">
          <span class="span1" v-for="(item, index) in timeList" :key="index">{{ item }}</span>
        </div>
        <div class="area" v-for="(it1, key1, dx1) in tableList" :key="dx1">
          <span class="date" :title="key1">{{ key1 }}</span>
          <div class="appoint-wrapper" v-for="(it2, dx2) in it1" :key="dx2">
            <span class="span1" v-if="it2 == null"></span>
            <span class="span1" :class="{ 'active': it2 && it2.isExplain == 1, 'disabled': it2 && it2.name }" v-else>{{
              it2 && it2.name }}</span>
          </div>
        </div>
      </template>

      <!-- <el-empty v-else description="暂无数据"></el-empty> -->
    </div>

    <el-dialog title="导出时段" :visible="signVisible" width="22%" @close="cancel" :close-on-click-modal="false">
      <el-form class="g-form-grid" ref="signForm" :model="signForm" :rules="rules">
        <el-form-item class="time-select" prop="times">
          <el-date-picker v-model="signForm.times" value-format="yyyy-MM-dd" type="daterange" range-separator="-"
            start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>

        </el-form-item>
      </el-form>

      <div slot="footer" class="footer mt-30 flex-box">
        <el-button @click="cancel">取消</el-button>
        <el-button @click="handleExport" type="primary">导出</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
export default {
  data() {
    const validateTime = (rule, value, callback) => {
      if (value && value.length <= 0 || !value) {
        callback(new Error('请选择导出时间'))
      } else {
        callback()
      }
    }

    return {
      form: {
        date: ''
      },
      signVisible: false,
      signForm: {
        times: null,
      },
      rules: {
        times: [{ required: true, validator: validateTime, trigger: 'blur' }],
      },
      timeList: [],
      recruitList: [],
      tableList: [],
      tableLoading: true
    }
  },

  mounted() {
    this.getExhibitionDetailList()
    window.addEventListener('keyup', this.keydown)

    // this.showRecruit()
    // this.getDropdownValue()
  },
  methods: {
    keydown(event) {
      if (event.keyCode == '13') {
        this.getExhibitionDetailList()
      }
    },

    showDialog() {
      this.signVisible = true
    },

    cancel() {
      this.signVisible = false
      this.$refs.signForm.resetFields()
    },

    getdiffdate(stime, etime) {
      //初始化日期列表，数组
      var diffdate = new Array();
      var i = 0;
      //开始日期小于等于结束日期,并循环
      while (stime <= etime) {
        diffdate[i] = stime;

        //获取开始日期时间戳
        var stime_ts = new Date(stime).getTime();

        //增加一天时间戳后的日期
        var next_date = stime_ts + (24 * 60 * 60 * 1000);

        //拼接年月日，这里的月份会返回（0-11），所以要+1
        var next_dates_y = new Date(next_date).getFullYear() + '-';
        var next_dates_m = (new Date(next_date).getMonth() + 1 < 10) ? '0' + (new Date(next_date).getMonth() + 1) + '-' : (new Date(next_date).getMonth() + 1) + '-';
        var next_dates_d = (new Date(next_date).getDate() < 10) ? '0' + new Date(next_date).getDate() : new Date(next_date).getDate();

        stime = next_dates_y + next_dates_m + next_dates_d;

        //增加数组key
        i++;
      }
      return diffdate;

    },

    getTableList(arr, date) {
      let results = arr, arrList = []
      if (results && results.length > 0) {
        let arr = []
        for (let m = 0; m < results.length; m++) {
          if (arr.indexOf(results[m].appointmentTime) == -1) {
            arr.push(results[m].appointmentTime)
          }
        }
        let tempObj = {}
        results.map((item, index) => {
          if (tempObj[item.exhibitonName] != null) {
            tempObj[item.exhibitonName].push(item)
          } else {
            let every = []
            every.push(item)
            tempObj[item.exhibitonName] = every
          }
        })
        return { date, timeList: arr, tableList: tempObj }
      }

    },

    handleExport() {
      this.$refs['signForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在导出，请稍等...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          let tempArrs = this.getdiffdate(this.signForm.times[0], this.signForm.times[1])
          const requests = [], exportList = []
          tempArrs.map(item => {
            requests.push(this.$api.volunteer.getExhibitionDetailList({ date: item }))
          })

          Promise.all(requests).then(responses => {
            responses.forEach((response, index) => {
              if (response.result && response.result.length) {
                let exportObj = this.getTableList(response.result, tempArrs[index])
                exportList.push(exportObj)
              }
            });

            // 1.创建一个工作簿
            let workbook = XLSX.utils.book_new();
            exportList.map(item => {
              let data = this.setExcelData(item.tableList, item.timeList)
              // 2.创建sheet对象
              let worksheet = XLSX.utils.aoa_to_sheet(data);
              // 3.将 sheet 对象插入工作簿
              XLSX.utils.book_append_sheet(workbook, worksheet, item.date);
            })

            // 生成Excel文件并导出
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
            saveAs(dataBlob, `预约情况表.xlsx`)
            this.cancel()

            loading.close()

          }).catch(error => {
            // 处理错误
            console.error('An error occurred:', error);
          });

        } else {
          return false;
        }
      });

      return



    },

    setExcelData(tableList, timeList) {
      const data = []
      let tempTableList = tableList,
        tempTimeList = timeList
      Object.entries(tempTableList).forEach(([key, arr], index) => {
        data.push([])

        arr.map(item => {
          data[index].push(item.name)
        })
      });


      for (let i = 0; i <= data.length - 1; i++) {
        data[i].unshift(Object.entries(tempTableList)[i][0])
      }

      tempTimeList.unshift('预约情况表')
      data.unshift(tempTimeList)

      return data
    },

    getExhibitionDetailList() {
      this.tableLoading = true
      this.tableList = []
      this.$api.volunteer.getExhibitionDetailList({
        ...this.form
      }).then(res => {
        this.tableLoading = false

        if (res.success) {
          let results = res.result, arrList = []
          if (results && results.length > 0) {
            let arr = []
            for (let m = 0; m < results.length; m++) {
              if (arr.indexOf(results[m].appointmentTime) == -1) {
                arr.push(results[m].appointmentTime)
              }
            }
            let tempObj = {}
            results.map((item, index) => {
              if (tempObj[item.exhibitonName] != null) {
                tempObj[item.exhibitonName].push(item)
              } else {
                let every = []
                every.push(item)
                tempObj[item.exhibitonName] = every
              }
              // this.$set(item, "appointList", JSON.parse(JSON.stringify(appointList)));
              // arr.push([])
              // if (index == 0) {
              //   this.tableHeaderList.unshift('预约情况表')
              //   this.tableHeaderList.push(item.appointmentDate)
              // } 
              // else {
              //   arr[index + 1].push(item.appointmentDate)
              // }
              // for (let m = 0; m < results.length; m++) {
              //   if (index == 0) {
              //     if (arr[0].indexOf(results[m].appointmentTime) == -1) {
              //       arr[0].push(results[m].appointmentTime)
              //     }
              //   }
              // }
            })
            // for (let m = 0; m < results.length; m++) {
            //   arr.map((it, dx) => {
            //     if (dx > 0) {
            //       if (it[0] == results[m].appointmentDate) {
            //         if ((dx - 1) == m) {
            //           it.push(results[m])
            //         } else {
            //           it.push('')
            //         }
            //       }
            //     }
            //   })
            // }
            // arr.forEach((item, index) => {
            //   for (let m = 0; m < results.length; m++) {
            //     if (index > 0) {
            //       if ((index - 1) == m) {
            //         item.push({ adultId: results[m].adultId, id: results[m].id, isExplain: results[m].isExplain })
            //       } else {
            //         item.push('')
            //       }
            //     }
            //   }
            // })
            arr.unshift('预约情况表')
            this.timeList = arr
            this.tableList = tempObj
          }

        }
      })
    },

    setExplain(obj) {
      if (!obj.name || obj.isExplain == 1) {
        return
      }
      this.$common.confirm(
        {
          title: '是否设置为讲解员？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$api.volunteer.setExplain({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('设置成功')
              this.getExhibitionDetailList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },


    // 获取下拉状态选择值
    getDropdownValue() {
      this.$http.get('/AppointTicket/getSettingTimesList').then(res => {
        if (res.success) {
          let timeList = res.result
          timeList.map(item => {
            this.timeList.push(item.startTime + ':' + item.endTime)
          })

          // this.timeList.unshift('预约情况表')
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // showRecruit() {
    //   this.$api.volunteer.showRecruit().then(res => {
    //     if (res.success) {
    //       this.recruitList = res.result
    //       this.form.name = this.recruitList[0]
    //       this.getExhibitionDetailList()
    //     }
    //   })
    // },

    restList() {
      this.$refs['form'].resetFields()
      this.timeList = []
      this.getExhibitionDetailList()
    },

  },

}
</script>

<style lang='scss' scoped>
.table-wrapper {
  .flex {
    display: flex;
  }

  .span1 {
    flex: 1;
    display: inline-block;
    box-sizing: border-box;
    height: 100%;
    border-right: 1px solid #606266;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.disabled {
      background-color: #e4e7ed;
    }

    &.c-p {
      cursor: pointer;

      &:hover {
        color: #0590ff;
      }

      &.active {
        background-color: #0590ff;
        color: #fff;
      }
    }
  }

  .header {
    display: flex;
    box-sizing: border-box;
    height: 30px;
    line-height: 30px;
    border: 1px solid #606266;
    border-right: none;
    border-bottom: none;

    .span1 {
      &:first-child {
        flex-basis: 150px;
        flex-shrink: 0;
        flex-grow: 0;
      }
    }
  }

  .area {
    display: flex;
    height: 30px;
    box-sizing: border-box;
    line-height: 30px;
    border: 1px solid #606266;
    border-bottom-width: 0;

    &:last-child {
      border-bottom: 1px solid #606266;
    }

    .date {
      flex-basis: 150px;
      flex-shrink: 0;
      text-align: center;
      display: inline-block;
      box-sizing: border-box;
      border-right: 1px solid #606266;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .appoint-wrapper {
      display: flex;
      flex: 1;
      flex-direction: row;

      &:last-child {
        .span1 {
          border: none;
        }
      }
    }
  }
}


.time-select {
  /deep/ .el-form-item__content {
    display: flex;
  }
}


/deep/ .footer {
  justify-content: flex-end;
}
</style>